import { isValidEmail } from '@/utils/validation';

export interface UserFormValues {
  first_name: string;
  last_name: string;
  email: string;
  role_ids: string[];
}

export interface UserFormErrors {
  first_name?: string;
  last_name?: string;
  email?: string;
  role_ids?: string;
}

export function validateUserForm(values: UserFormValues): UserFormErrors {
  const errors: UserFormErrors = {};

  if (!values.first_name) errors.first_name = 'First name is required';
  if (!values.last_name) errors.last_name = 'Last name is required';
  if (!values.email) {
    errors.email = 'Email is required';
  } else if (!isValidEmail(values.email)) {
    errors.email = 'Enter a valid email address';
  }
  if (values.role_ids.length === 0) {
    errors.role_ids = 'At least one role must be selected';
  }

  return errors;
}

export function hasAnyError(errors: UserFormErrors): boolean {
  return Object.keys(errors).length > 0;
}
